export const UpdateProcedureFilter = 'filter/procedure/UPDATE'
export const UpdateRecordFilter = 'filter/record/UPDATE'
export const UpdateTaskFilter = 'filter/task/UPDATE'
export const UpdateDocumentFilter = 'filter/documents/UPDATE'
export const UpdateAccessRequestFilter = 'filter/accessRequest/UPDATE'
export const UpdateBreachFilter = 'filter/breach/UPDATE'
export const UpdateCompanyFilter = 'filter/company/UPDATE'
